<template>
  <page>
    <page-poster
      :headline="$t('home.poster.heading')"
      :paragraphs="paragraphs"
      :class="$style['home-poster']"
    >
      <join-us-button class="btn" />
    </page-poster>
    <home-video />
    <home-info-rows />
    <home-how-it-work-section />
    <social-dilema-section />
    <home-customer-quotes-section />
    <page-info-footer-row />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePoster from '@/components/common/PagePoster.vue';
import JoinUsButton from '@/components/common/JoinUsButton.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import HomeInfoRows from '@/components/home/HomeInfoRows.vue';
import HomeHowItWorkSection from '@/components/home/HomeHowItWorkSection.vue';
import HomeCustomerQuotesSection from '@/components/home/HomeCustomerQuotesSection.vue';
import SocialDilemaSection from '@/components/home/SocialDilemaSection.vue';
import HomeVideo from '@/components/home/HomeVideo.vue';

export default {
  components: {
    Page,
    PagePoster,
    JoinUsButton,
    PageInfoFooterRow,
    HomeInfoRows,
    HomeHowItWorkSection,
    HomeCustomerQuotesSection,
    HomeVideo,
    SocialDilemaSection,
  },
  data() {
    return {
      paragraphs: [
        this.$t('home.poster.paragraph-1'),
        this.$t('home.poster.paragraph-2'),
        this.$t('home.poster.paragraph-3'),
      ],
    };
  },
};
</script>

<style lang="scss" module>
.home-poster {
  h2 {
    max-width: 511px;
    text-align: center;
  }
}
</style>

<style lang="scss" scoped>
.btn {
  margin-top: 24px;
}
</style>
